export default {
  "title": "FreeDive Ai",
  "heroHeadline": "Trainiere jeden Tag und verbessere deine Freitauch-Fähigkeiten!",
  "heroSubheadline": "Die ultimative KI-Apnoe-Trainings-App für Freitaucher, Speerfischer und Meerjungfrauen.",
  "featuresHeader": "Warum FreeDive Ai wählen?",
  "featuresSubtitle": "Alles, was du brauchst, um tiefer zu tauchen, länger den Atem anzuhalten und sicher zu bleiben.",
  "feature1Title": "KI-Apnoe-Training",
  "feature1Desc": "Individuelle CO2- und O2-Tabellen, die von der KI basierend auf deinen persönlichen Bestleistungen erstellt werden, um deine Atemanhaltzeiten sicher zu verlängern.",
  "feature2Title": "Smartes Logbuch",
  "feature2Desc": "Protokolliere deine Freitauch- und Speerfischen-Sessions. Verfolge Tiefen, Zeiten, Herzfrequenz und SpO2 an einem Ort.",
  "feature3Title": "Wettbewerbe & Lizenzen",
  "feature3Desc": "Behalte deine Freitauch-Lizenzen im Auge und bleibe über weltweite Wettbewerbe und Veranstaltungen auf dem Laufenden.",
  "screenshotsTitle": "App-Screenshots",
  "copyright": "© DomiLabs. All rights reserved."
};
